import { VStack } from "@gluestack-ui/themed";
import { InfoSectionProps } from "@repo/core/components/layout/ProposalAccordion/components/InfoSection/types";
import { Text } from "@repo/core/components/core/Text";

export const InfoSection = ({ title, value }: InfoSectionProps) => {
  return (
    <VStack gap="$1">
      <Text fontSize="$xs" fontWeight={500} color="$textLight700">
        {title}
      </Text>
      <Text color="$textLight900">{value}</Text>
    </VStack>
  );
};
